/* My Sunshine — Fly to cart animation (Polaroid • slow float across screen) */
(() => {
  // Prevent double-loading
  if (window.MS_FLY_TO_CART_LOADED) return;
  window.MS_FLY_TO_CART_LOADED = true;

  const reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const CART_SELECTORS = [
    '#cart-icon-bubble',
    'a#cart-icon-bubble',
    'a[href="/cart"]',
    'a[href^="/cart"]',
    '.header__icon--cart',
    '.header__icon.header__icon--cart'
  ];

  function getCartEl() {
    for (const sel of CART_SELECTORS) {
      const el = document.querySelector(sel);
      if (el) return el.closest('a, button, .header__icon, #cart-icon-bubble') || el;
    }
    return null;
  }

  // Pick the correct “active” product image on product pages (Craft/Dawn)
  function getBestImageFromContext(ctx) {
    // 1) Product page: active media image
    const active =
      document.querySelector('.product__media-item.is-active img') ||
      document.querySelector('.product__media-item[aria-hidden="false"] img') ||
      document.querySelector('.product__media img');

    if (active && active.getBoundingClientRect().width > 40) return active;

    // 2) Collection cards: nearest card image
    const cardImg = ctx.querySelector('.card__media img, .card-wrapper img');
    if (cardImg && cardImg.getBoundingClientRect().width > 40) return cardImg;

    // 3) Fallback: first visible image in context
    const imgs = [...ctx.querySelectorAll('img')].filter((img) => {
      const r = img.getBoundingClientRect();
      return r.width > 40 && r.height > 40 && r.top < window.innerHeight && r.bottom > 0;
    });

    return imgs[0] || null;
  }

  // Create a mini Polaroid that ALWAYS shows the product image (no blank “white blob”)
  function createPolaroidFlyer(fromImg, fromRect) {
    // Tweak size if you want (bigger = easier to see)
    const width = 78;
    const height = 92;

    // Start centred on the product image
    const startX = fromRect.left + (fromRect.width / 2) - (width / 2);
    const startY = fromRect.top + (fromRect.height / 2) - (height / 2);

    // Polaroid frame
    const flyer = document.createElement('div');
    flyer.className = 'ms-fly-polaroid';
    flyer.style.position = 'fixed';
    flyer.style.left = `${startX}px`;
    flyer.style.top = `${startY}px`;
    flyer.style.width = `${width}px`;
    flyer.style.height = `${height}px`;
    flyer.style.background = '#fff';
    flyer.style.borderRadius = '16px';
    flyer.style.padding = '5px';
    flyer.style.boxShadow = '0 16px 30px rgba(0,0,0,0.22)';
    flyer.style.zIndex = '999999';
    flyer.style.pointerEvents = 'none';
    flyer.style.willChange = 'transform, opacity';
    flyer.style.opacity = '1';
    flyer.style.transform = 'translate3d(0,0,0) scale(1) rotate(-2deg)';
    flyer.style.overflow = 'hidden';

    // Inner photo area
    const inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '100%';
    inner.style.borderRadius = '12px';
    inner.style.overflow = 'hidden';

    // Clone the real image so it renders instantly
    const innerImg = fromImg.cloneNode(true);
    innerImg.removeAttribute('srcset');
    innerImg.removeAttribute('sizes');
    innerImg.src = fromImg.currentSrc || fromImg.src;
    innerImg.style.width = '100%';
    innerImg.style.height = '100%';
    innerImg.style.display = 'block';
    innerImg.style.objectFit = 'cover';

    inner.appendChild(innerImg);
    flyer.appendChild(inner);
    document.body.appendChild(flyer);

    return flyer;
  }

  function flyToCart(fromImg, cartEl) {
    if (reduceMotion) return;
    if (!fromImg || !cartEl) return;

    const fromRect = fromImg.getBoundingClientRect();
    const toRect = cartEl.getBoundingClientRect();

    const flyer = createPolaroidFlyer(fromImg, fromRect);

    // Centres for movement
    const fromCenterX = fromRect.left + fromRect.width / 2;
    const fromCenterY = fromRect.top + fromRect.height / 2;
    const toCenterX = toRect.left + toRect.width / 2;
    const toCenterY = toRect.top + toRect.height / 2;

    const dx = toCenterX - fromCenterX;
    const dy = toCenterY - fromCenterY;

    // Gentle float arc (like your reference)
    const lift = Math.min(140, Math.max(70, Math.abs(dx) * 0.10));

    // Slow, visible glide across the screen
    const duration = 1000; // increase to 1600 for even slower

    // Use Web Animations API (smooth on iOS Safari)
    const anim = flyer.animate(
      [
        { transform: 'translate3d(0,0,0) scale(1) rotate(-2deg)', opacity: 1 },
        {
          transform: `translate3d(${dx * 0.55}px, ${dy * 0.55 - lift}px, 0) scale(0.92) rotate(1deg)`,
          opacity: 0.98
        },
        {
          transform: `translate3d(${dx}px, ${dy}px, 0) scale(0.60) rotate(3deg)`,
          opacity: 0.92
        }
      ],
      {
        duration,
        easing: 'cubic-bezier(0.3, 1.4, 0.6, 1)',
        fill: 'forwards'
      }
    );

    // Cart pop near the end (feels like it “arrives”)
    window.setTimeout(() => {
      cartEl.classList.add('ms-cart-pop');
      window.setTimeout(() => cartEl.classList.remove('ms-cart-pop'), 280);
    }, Math.round(duration * 0.85));

    anim.onfinish = () => flyer.remove();
  }

  function clickHandler(e) {
    const btn = e.target.closest(
      'button[name="add"], button[type="submit"], .product-form__submit, [data-add-to-cart]'
    );
    if (!btn) return;

    const form = btn.closest('form[action*="/cart/add"]') || btn.closest('form');
    if (!form) return;

    const cartEl = getCartEl();
    if (!cartEl) return;

    const context =
      form.closest(
        '.product, .product__info-wrapper, .product__media-wrapper, .card-wrapper, .card, .grid__item, main'
      ) || document;

    const img = getBestImageFromContext(context);
    flyToCart(img, cartEl);
  }

  function injectCssOnce() {
    if (document.getElementById('ms-fly-css')) return;
    const style = document.createElement('style');
    style.id = 'ms-fly-css';
    style.textContent = `
      .ms-cart-pop { transform: scale(1.14); transition: transform 180ms ease; }
      @media (prefers-reduced-motion: reduce) { .ms-cart-pop { transition: none !important; } }
    `;
    document.head.appendChild(style);
  }

  function bind() {
    injectCssOnce();
    document.removeEventListener('click', clickHandler, true);
    document.addEventListener('click', clickHandler, true);
  }

  bind();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  }
})();